// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".homeIcon a[data-v-bc37f0fa]{cursor:auto}.homeIcon a .b-icon.bi[data-v-bc37f0fa]{color:var(--breadcrumbIconFont);cursor:auto}", ""]);
// Exports
module.exports = exports;
